<!-- eslint-disable max-len -->
<template>
  <div>
    <div
      v-if="!isLoading"
      class="wrap-title-component"
    >
      {{ titleComponent }}
    </div>
    <h5
      v-if="!isLoading"
      class="mb-2"
    >
      {{ titleView }}
    </h5>

    <div v-if="!isLoading">
      <!-- Button -->
      <div class="d-flex align-items-center mb-2">
        <b-button
          class="btn grey btn-import-form m__r--5"
          disabled
        >
          <i class="fa fa-plus fa-lg"/> Add
        </b-button>
        <b-button
          class="btn grey btn-import-form m__r--5"
          disabled
        >
          <i class="fa fa-cloud-upload fa-lg"/> Import
        </b-button>
        <b-button
          class="btn grey btn-import-form m__r--5"
          disabled
        >
          <i class="fa fa-download fa-lg"/> Export
        </b-button>
        <b-button
          class="btn grey btn-import-form m__r--5"
          disabled
        >
          <i class="fa fa-filter fa-lg"/> Filter
        </b-button>
      </div>

      <!-- Calendar -->
      <j-calender-view-widget
        :form-data="formData"
        :form-ui="formUi"
        :use-title="false"
      />
    </div>

    <div
      v-else
      class="skeleton-component"
    />
  </div>
</template>

<script>
/* eslint-disable max-len */
import jwtDecode from 'jwt-decode';
import { mapActions } from 'vuex';
import jMixComponentMultiDetailView from '@/mixins/form-ui-v2/jMixComponentMultiDetailView';
import jCalenderViewWidget from '@/views/widget/widget-card/jCalenderViewWidget';

export default {
  components: {
    jCalenderViewWidget,
  },

  mixins: [jMixComponentMultiDetailView],

  props: {
    forDetailParent: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      formUi: null,
      formData: null,
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },

  methods: {
    ...mapActions('jStoreFormUi', [
      'actionGetSetupFormUi', 'actionGetSetupMultiFormUi', 'getFormDataUi',
    ]),

    async getDetailComponent() {
      const response = await this.requestDataComponent();
      if (response) {
        this.detailComponent = response.data.data[0].calendar_view;
        this.titleView = this.detailComponent.title;
        this.getDataCalendar();
      }
    },

    getDataCalendar() {
      const req = {
        page: 1,
        limit: 1,
        filter: {
          id: [this.formUiId],
        },
      };

      if (this.isMultipleUi) {
        this.actionGetSetupMultiFormUi(req).then((res) => {
          const response = res.data[0];
          this.formUi = response;

          if (response.form_data_id) {
            const reqData = {
              form_data_id: response.form_data_id,
            };
            this.getFormDataUi(reqData).then((param) => {
              this.formData = param.data;
            });
          } else {
            this.formData = {
              columns: response.data_source.external_url.columns,
              primary_key: '',
            };
          }
          this.isLoading = false;
        });
      } else {
        this.actionGetSetupFormUi(req).then((res) => {
          const response = res.data[0];
          this.formUi = response;

          if (response.form_data_id) {
            const reqData = {
              form_data_id: response.form_data_id,
            };
            this.getFormDataUi(reqData).then((param) => {
              this.formData = param.data;
            });
          } else {
            this.formData = {
              columns: response.data_source.external_url.columns,
              primary_key: '',
            };
          }
          this.isLoading = false;
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dummy/DummyCalendarView.vue